import React, { PureComponent } from 'react';

import { translate } from '../../base/i18n';

/**
 * The type of the React {@code Component} props of {@link Tab}.
 */
type Props = {

    /**
     * The index of the tab.
     */
    index: number,

    /**
     * Indicates if the tab is selected or not.
     */
    isSelected: boolean,

    /**
     * The label of the tab.
     */
    label: string,

    /**
     * Handler for selecting the tab.
     */
    onSelect: Function
}

/**
 * A React component that implements tabs.
 *
 */
class Tab extends PureComponent<Props> {
    /**
     * Initializes a new {@code Tab} instance.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);

        this._onSelect = this._onSelect.bind(this);
    }

    _onSelect: () => void;

    /**
     * Selects a tab.
     *
     * @returns {void}
     */
    _onSelect() {
        const { index, onSelect } = this.props;

        onSelect(index);
    }

    /**
     * Implements the React Components's render method.
     *
     * @inheritdoc
     */
    render() {
        const { index, isSelected, label, t } = this.props;
        const className = `tab${isSelected ? ' selected' : ''}`;

        return (
            <div
                className = { className }
                href = '#'
                key = { index }
                onClick = { this._onSelect } >
                <div className = 'd-flex w-100 justify-content-between'>
                    <h5 className = 'mb-1'>{label}</h5> <small>{t('prejoin.daysAgo', {
                        daysCount: 3
                    })}</small>
                </div>
            </div>
        );
    }
}

export default translate(Tab);
